import { consentState, isFeatureEnabled } from './consent'
import { enqueue } from './queue'
import { normalizeRoute } from './route'
import { EVENT_VERSION, track } from './track'
import { uuid } from './uuid'

let anonymousToken: string | null = null

// One-shot token for the no-consent mode: memory only, never stored and never
// linked to a person (cookie guide §3.2, §4.3).
function pageToken(): string {
  anonymousToken ??= uuid()
  return anonymousToken
}

export function trackPageView(pathname: string): void {
  try {
    if (typeof window === 'undefined' || !isFeatureEnabled()) return
    const state = consentState()
    const props = { route: normalizeRoute(pathname), consent_state: state }
    if (state === 'granted') {
      track({ name: 'page_view', props })
      return
    }
    const token = pageToken()
    enqueue(
      {
        event_id: uuid(),
        event_name: 'page_view',
        event_version: EVENT_VERSION,
        occurred_at: new Date().toISOString(),
        distinct_id: token,
        session_id: token,
        props
      },
      { anonymous: true }
    )
  } catch {
    // analytics must never break the app
  }
}

export function resetAnonymousTokenForTests(): void {
  anonymousToken = null
}
